import { render } from "./ChordTable.vue?vue&type=template&id=3b781ea3&scoped=true"
import script from "./ChordTable.vue?vue&type=script&lang=js"
export * from "./ChordTable.vue?vue&type=script&lang=js"

import "./ChordTable.vue?vue&type=style&index=0&id=3b781ea3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b781ea3"

export default script